import { api, URLs } from '@/libs/api'
import type {
  ApiResponse,
  StoreOpeningHours,
  UpdateOpeningHoursParams,
  UpdateSpecialOpeningHoursParams,
  WorkingHoursParams,
  WorkingHoursResponse,
} from '@/libs/interfaces'
import { workingHoursApiMock } from '@/libs/mocks/handlers/workingHours'

const workingHoursApiReal = {
  getOpeningHours: async (params: WorkingHoursParams): Promise<WorkingHoursResponse> => {
    const { storeID, from, to } = params
    const queryParams: Record<string, string> = {}
    if (from) queryParams.from = from
    if (to) queryParams.to = to
    const response = await api.get<ApiResponse<WorkingHoursResponse>>(
      URLs.WorkingHours.openingHours(storeID),
      queryParams,
    )
    return response.data.data
  },

  updateOpeningHours: async (params: UpdateOpeningHoursParams): Promise<StoreOpeningHours> => {
    const { storeID, ...payload } = params
    const response = await api.post<ApiResponse<StoreOpeningHours>>(
      URLs.WorkingHours.openingHours(storeID),
      payload,
    )
    return response.data.data
  },

  updateSpecialOpeningHours: async (
    params: UpdateSpecialOpeningHoursParams,
  ): Promise<UpdateSpecialOpeningHoursParams> => {
    const response = await api.patch<ApiResponse<UpdateSpecialOpeningHoursParams>>(
      URLs.WorkingHours.specialOpeningHours(params.storeID),
      params,
    )
    return response.data.data
  },
}

export const workingHoursApi: typeof workingHoursApiReal = __IS_MOCK_MODE__
  ? workingHoursApiMock
  : workingHoursApiReal
